import React from "react";
import { SHOW_ALL_OPTION } from "components/Elements/Filters/constants";
import { Typography, Box } from '@mui/material';
import { makeStyles } from "tss-react/mui";
import ColourConstants from "helpers/colourConstants";
import { useFilters } from "../../../../components/Elements/Filters/FilterContext";
import { changeDate } from "helpers/date";

const useStyles = makeStyles()((theme) => ({
  header: {
    color: ColourConstants.commonText,
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 4,
    lineHeight: 1.2
  },
  subHeader: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    marginBottom: 2
  },
  questionInfo: {
    color: 'rgba(0, 0, 0, 0.75)',
    fontSize: '0.95rem',
    lineHeight: 1.5,
    marginTop: 6,
    marginBottom: 6,
    textAlign: 'center',
    fontWeight: 500,
    maxWidth: '80%'
  },
  dateRange: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    display: 'flex',
    alignItems: 'center',
    marginTop: 2
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const ChartTitle = ({
  datas = [],
  title,
  subTitle,
  afterClick,
  isConditionMonitor = false,
  conditionMonitorData,
  isDrilledDown = false
}) => {
  const { classes } = useStyles();
  const { filterValues } = useFilters();
  
  // Get timeframe data directly from filters
  const timeframe = filterValues?.timeframe?.value;
  const startDateTime = timeframe?.fromDate ? changeDate(timeframe.fromDate) : null;
  const endDateTime = timeframe?.toDate ? changeDate(timeframe.toDate) : null;
  const isShowAll = timeframe?.name === SHOW_ALL_OPTION.name;
  
  // Determine if we should show the date range (when timeframe is not "Show All")
  const showDateRange = timeframe && !isShowAll && startDateTime && endDateTime;
  
  // Get timezone information
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2];
  
  // Get question filter details if available
  const questionFilter = filterValues?.question?.value;
  const hasQuestionFilter = !isDrilledDown && questionFilter && 
    (questionFilter.stageName || questionFilter.zoneName || 
     questionFilter.taskName || questionFilter.questionName);
     
  // Format the question details if available
  const questionDetails = hasQuestionFilter ? (
    <span>
      {questionFilter.stageName && <span>{questionFilter.stageName}</span>}
      {questionFilter.zoneName && (
        <span>
          {questionFilter.stageName && <span> • </span>}
          {questionFilter.zoneName}
        </span>
      )}
      {questionFilter.taskName && (
        <span>
          {(questionFilter.stageName || questionFilter.zoneName) && <span> • </span>}
          {questionFilter.taskName}
        </span>
      )}
      {questionFilter.questionName && (
        <span>
          {(questionFilter.stageName || questionFilter.zoneName || questionFilter.taskName) && <span> • </span>}
          {questionFilter.questionName}
        </span>
      )}
    </span>
  ) : '';

  return (
    <div className={classes.container}>
      <Typography className={classes.header}>{title}</Typography>
      {subTitle && (
        <Typography className={classes.subHeader}>{subTitle}</Typography>
      )}
      {hasQuestionFilter && (
        <Typography className={classes.questionInfo}>
          {questionDetails}
        </Typography>
      )}
      {showDateRange && (
        <Typography className={classes.dateRange} sx={{ fontWeight: 500 }}>
          {`${startDateTime} - ${endDateTime}`}
          <Box component="span" sx={{ marginLeft: 1, fontWeight: 400 }}>
            ({timezoneAbbr || timezone})
          </Box>
        </Typography>
      )}
      {isConditionMonitor && !hasQuestionFilter && (
        <Typography className={classes.subHeader}>
          {conditionMonitorData}
        </Typography>
      )}
    </div>
  );
}; 
